<template>
  <div
    class="course-wrap"
    :class="{ 'electron-course-list': isElectron, 'h5-course-wrap': isH5 }"
  >
    <!-- 标题区域 -->
    <SectionHeader
      title="精品课推荐"
      subtitle="严选名师好课，打造最佳学习体验"
    />
    <!-- 课程列表 -->
    <div class="course-list grid grid-cols-2 gap-3 md:grid-cols-2 lg:grid-cols-4 md:gap-6">
      <CourseCard
        class="snap-start"
        :groupInfo="item.group_buy_info || {}"
        v-for="item in couseList"
        :key="item.id"
        :courseInfo="item"
        :orgInfo="item.org"
      />
    </div>
  </div>
</template>

<script>
import { isH5, isPad } from "@saas/components/src";
import CourseCard from "./CourseCard.vue";
import SectionHeader from "./SectionHeader.vue";
export default {
  props: {
    couseList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data: function () {
    return {
      isH5: isH5(),
      isPad: isPad(),
      isElectron: window.isElectron,
    };
  },
  components: {
    CourseCard,
    SectionHeader,
  },
  methods: {
    handleCourseInfo(item) {
      return {
        ...item,
        ...item.course_info,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.no-scrollbar {
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
}

// 使用 CSS 变量（仅桌面端）
@media (min-width: 768px) {
  .course-wrap {
    .course-list {
      gap: var(--card-gap, 1.5rem);
    }
  }
}

// h5样式
.course-wrap.h5-course-wrap {
  padding: 0.43rem 0.28rem 0;
  .course-list {
    display: grid !important;
    grid-template-columns: repeat(2, 1fr) !important;
    gap: 0.16rem;
    width: 100%;
  }
}
</style>
